export default __webpack_public_path__ + "static/media/144.c992e178.jpg";